import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';
cookiesPolicy({
  position: 'bottom',
  enableModal: true,
  // enableOneGTMContainer: true,
  imgSrc: '/img/cookie-policy/cookie.svg',
});

import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import configureLandingPageComponents from './configureLandingPageComponents';


import 'fg-frontend/ramjet/liveValidation';
import configureWebActions from "./configureWebActions";

import('./components/plUpload/fg.upload');

connectWebComponents(configureLandingPageComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);




// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureLandingPage.js